// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"3ba0b1a0","64":"6b3072fd","79":"6446a284","173":"5e6a4f76","388":"f73ed12a","500":"01b84bd0","511":"eedbef8d","561":"229bfd56","616":"53c472b2","746":"f4b2b579","861":"5c06af27","886":"a40421cc","891":"c8adb135","929":"fa7d445a","968":"f359e895"}[chunkId] + ".chunk.js";
};